import { CCardFooter } from "@coreui/react";
import { AttachFile, Delete } from "@mui/icons-material";
import { Box, Button, Card, CardContent, CardHeader, Divider, IconButton, Select, Table, TableBody, TableCell, TableHead, TableRow, TextField, Typography } from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import { T_Error } from "../../common/model/errorModel";
import { useState } from "react";
import { initialAlert, useAlert } from "../../provider/AlertContextProvider";
import apis from "../../common/apis";

export default function ErrorEdit(){
    const { state } = useLocation();
    // state.inqueryData 에서 넘어온 item 객체를 꺼낼 수 있습니다.
    const item : T_Error = state?.item;
    const [data,setData] = useState<T_Error>(item)
    const nav = useNavigate();
    const {alert,setAlert} = useAlert();
    const saveData = async()=>{
            
        if(data.title === "" || data.title === undefined){
            setAlert({...alert,visible:true,title:"확인",msg:"오류내용을 입력하여 주십시요"})   
            return;
        }
        if(data.errcode == "" || data.errcode === undefined){
            setAlert({...alert,visible:true,title:"확인",msg:"오류코드를 입력하여 주십시요"})   
            return;
        }
         
        setAlert({...alert,title:"확인",msg:"정말로 수정 하시겠습니가?",visible:true,buttonList:[
            {
                text:"예"
                ,variant:"contained"
                ,onPress:async()=>{
                    const result = await apis.error.errorUpdate(data);
                    console.log("result:",result);
                    if(result.code=="1"){
                        setAlert(initialAlert);
                        setAlert({...alert,visible:true,title:"확인",msg:"수정이 완료되었습니다."});
                        nav("/error")
                    }else{
                        setAlert(initialAlert);
                        setAlert({...alert,visible:true,title:"확인",msg:"수정중 오류가 발생했습니다.."})
                    }
           
                }
            },{
                text:"아니요"
                ,variant:"outlined"
                ,onPress:()=>{
                    setAlert(initialAlert);
                }
            }
        ]})
    }
    return(
        <>
         <Card >
        <CardHeader title="에러수정" sx={{pb:0,mb:0}}/>
        <CardContent>
            <Divider />
        <Table  stickyHeader aria-label="sticky table"  sx={{borderTopWidth:2
          }} > 
            <TableHead />
            <TableBody>
            <TableRow>
                    <TableCell component="th" scope="row" sx={{width:150}}>
                          에러코드
                        </TableCell>      
                        <TableCell sx={{textAlign:'left'}}>
                          <TextField  size="small" fullWidth value={data.errcode || ''} onChange={(event)=>{setData({...data,errcode:event.target.value})}} />
                        </TableCell>      

        </TableRow>        

        <TableRow>
                    <TableCell component="th" scope="row" sx={{width:150}}>
                          오류내용용
                        </TableCell>      
                        <TableCell sx={{textAlign:'left'}}>
                          <TextField multiline
                            rows={10}
                            fullWidth 
                            value={data.title || ''} onChange={(event)=>{setData({...data,title:event.target.value})}}
                          />
                        </TableCell>      

        </TableRow>          
        <TableRow>
                    <TableCell component="th" scope="row" sx={{width:150}}>
                          답변
                        </TableCell>      
                        <TableCell sx={{textAlign:'left'}}>
                          <TextField multiline
                            rows={10}
                            fullWidth 
                            value={data.content || ''} onChange={(event)=>{setData({...data,content:event.target.value})}}
                          />
                        </TableCell>      

        </TableRow>          

     
        </TableBody>

        </Table>

        </CardContent>
        <CCardFooter style={{   display: 'flex',justifyContent:'center',textAlign:'center',paddingBottom:10, gap: '1rem'}}  >
        <Button variant="contained" onClick={()=>{
            saveData();
        }}>수정</Button>
        <Button variant="outlined" onClick={()=>{
                nav(-1);
            }}>취소</Button>

        </CCardFooter>
    </Card>
        </>
    )
}